<template>
    <vue-good-table
        styleClass="vgt-table bordered"
        theme="polar-bear"
        :columns="columns"
        :rows="rows"
        :group-options="{
            enabled: true
        }"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }"
        class="cargo-details mb-50"
    >
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import {
  BPagination,
  BFormSelect,
} from "bootstrap-vue";
export default {
    name: "Parties",
    components: {
        VueGoodTable,
        BPagination,
        BFormSelect,
    },
    props: {
        data: Array
    },
    data() {
        return {
            pageLength: 3,
            rows: [],
            searchTerm: '',
            columns: [
                {
                    label: "Company Name",
                    field: 'groupData.companyName',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Address",
                    field: 'groupData.address',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Contact",
                    field: 'groupData.contact',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Email",
                    field: 'groupData.email',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Tel",
                    field: 'groupData.tel',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                }
            ]
        }
    },
    created() {
        this.data.forEach((element) => {
            this.rows.push({
                mode: 'span',
                label: element.groupName,
                html: false,
                children : [element]
            })
        })      
    }
}
</script>

<style>
.cargo-details .vgt-table.polar-bear td {
  text-align: center;
  vertical-align: middle !important;
}
.column-desc {
    padding-left: 10px;
    text-align: left !important;
    max-height: 120px;
    overflow-y: auto;
    margin-bottom : 0 !important
}
</style>